import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BrandModule } from '@features/brand/brand.module';
import { CartModule } from '@features/cart/cart.module';
import { CategoryModule } from '@features/category/category.module';
import { NotificationModule } from '@features/notification/notification.module';
import { UserModule } from '@features/user/user.module';
import { FcDrawerModule } from '@shared/components/fc-drawer/fc-drawer.module';
import { FcDropdownModule } from '@shared/components/fc-dropdown/fc-dropdown.module';
import { SharedModule } from '@shared/shared.module';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { MobileMenuComponent } from './components/mobile-menu/mobile-menu.component';
import { MobileNavigationComponent } from './components/mobile-navigation/mobile-navigation.component';
import { SearchComponent } from './components/search/search.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { LayoutComponent } from './layout.component';

@NgModule({
  declarations: [
    LayoutComponent,
    MobileNavigationComponent,
    HeaderComponent,
    FooterComponent,
    MobileMenuComponent,
    SearchComponent,
  ],
  imports: [
    LayoutRoutingModule,
    CommonModule,
    SharedModule,
    FcDropdownModule,
    CategoryModule,
    BrandModule,
    NotificationModule,
    CartModule,
    UserModule,
    FcDrawerModule,
  ],
  exports: [FooterComponent],
})
export class LayoutModule {}
